import React from 'react';
import { Target, History, Bell, Settings, LineChart, Shield } from 'lucide-react';
import { useApp } from '@/context/AppContext';

const Sidebar = ({ view, setView, recoCount, t, onLogoClick, adminMode }) => {
  const { lang, setLang } = useApp();

  const navItems = [
    { id: 'active', icon: Target, label: t.app.active, badge: recoCount },
    { id: 'history', icon: History, label: t.app.history },
    { id: 'performance', icon: LineChart, label: t.app.performance },
    { id: 'alerts', icon: Bell, label: t.app.alerts, badge: 2 },
    { id: 'settings', icon: Settings, label: t.app.settings }
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo" onClick={onLogoClick} style={{ cursor: 'pointer' }}>
          <div className="logo-mark" style={adminMode ? { 
            background: 'linear-gradient(135deg, #f5576c 0%, #f093fb 100%)',
            boxShadow: '0 0 20px rgba(245, 87, 108, 0.4)'
          } : {}}>Ax</div>
          <div>
            <div className="logo-text" style={{ fontSize: '1.125rem' }}>AX<span>-IOM</span></div>
            <div className="sidebar-tagline">
              {adminMode ? '🔓 Admin Mode' : 'Decide with method'}
            </div>
          </div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="nav-label">Platform</div>
          {navItems.map(n => (
            <div 
              key={n.id} 
              className={`nav-item ${view === n.id ? 'active' : ''}`} 
              onClick={() => setView(n.id)}
            >
              <n.icon size={18} />
              <span>{n.label}</span>
              {n.badge && <span className="nav-badge">{n.badge}</span>}
            </div>
          ))}
        </div>
      </nav>

      <div className="sidebar-footer">
        {adminMode ? (
          <div className="tier-badge" style={{ 
            background: 'linear-gradient(135deg, rgba(245, 87, 108, 0.15) 0%, rgba(240, 147, 251, 0.15) 100%)',
            borderColor: 'rgba(245, 87, 108, 0.3)'
          }}>
            <Shield size={18} style={{ color: '#f5576c' }} />
            <div>
              <span style={{ 
                fontSize: '0.6875rem', fontWeight: 700, color: '#f5576c',
                display: 'block', marginBottom: 2
              }}>ADMIN</span>
              <span className="tier-text" style={{ fontSize: '0.75rem' }}>Critères visibles</span>
            </div>
          </div>
        ) : (
          <div className="tier-badge">
            <span className="tier-label">PRO</span>
            <span className="tier-text">{t.app.stocks} & {t.app.crypto}</span>
          </div>
        )}
        <div className="lang-toggle">
          <button 
            className={`lang-btn ${lang === 'fr' ? 'active' : ''}`} 
            onClick={() => setLang('fr')}
          >FR</button>
          <button 
            className={`lang-btn ${lang === 'en' ? 'active' : ''}`} 
            onClick={() => setLang('en')}
          >EN</button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
